import { createExternalRouteRef } from '@backstage/core-plugin-api';

import { entitiesRouteRef } from '@spotify/confidence-entities-react';

export enum ExternalRoutesIds {
  entities = 'entities',
  factTablesCreate = 'factTablesCreate',
}

export { entitiesRouteRef };

export const factTablesCreateRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.factTablesCreate,
  optional: true,
});
